import React, { useState } from "react";
import styles from "./SupervisorPin.module.css";

import { InputField, Modal, SubmitButton, TextComponent } from "../../../components";
import Password from "antd/es/input/Password";
import { VscEye } from "react-icons/vsc";
import { TbEyeClosed } from "react-icons/tb";
import HeadingComponent from "../../../components/HeadingComponent/HeadingComponent";

const SupervisorPin = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirnPassword, setConfirnPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [NpasswordVisible, setNPasswordVisible] = useState(false);
  const [CpasswordVisible, setCPasswordVisible] = useState(false);
  const [pinModal,setPinModal] = useState(false)

  return (
    <div className={styles.AccountContent}>

      <TextComponent text={"Change Supervisor PIN"} className={styles.labelText} />

      <InputField
        label={"Current Supervisor PIN"}
        style={{ marginTop: "30px" }}
        placeholder={"●●●●●●●●●●"}
        value={currentPassword}
        onChange={(e) => setCurrentPassword(e.target.value)}
        rightIcon={
          passwordVisible ? (
            <VscEye size={20} color={"var(--input-icon)"} />
          ) : (
            <TbEyeClosed size={20} color={"var(--input-icon)"} />
          )
        }
        onRightIconPress={() => setPasswordVisible(!passwordVisible)}
        type={passwordVisible ? "text" : "password"}
      />

      <InputField
        label={"New Supervisor PIN"}
        style={{ marginTop: "30px" }}
        placeholder={"●●●●●●●●●●"}
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        rightIcon={
          NpasswordVisible ? (
            <VscEye size={20} color={"var(--input-icon)"} />
          ) : (
            <TbEyeClosed size={20} color={"var(--input-icon)"} />
          )
        }
        onRightIconPress={() => setNPasswordVisible(!NpasswordVisible)}
        type={NpasswordVisible ? "text" : "password"}
      />
      <InputField
        label={"Confirm Supervisor PIN"}
        style={{ marginTop: "30px" }}
        placeholder={"●●●●●●●●●●"}
        value={confirnPassword}
        onChange={(e) => setConfirnPassword(e.target.value)}
        rightIcon={
          CpasswordVisible ? (
            <VscEye size={20} color={"var(--input-icon)"} />
          ) : (
            <TbEyeClosed size={20} color={"var(--input-icon)"} />
          )
        }
        onRightIconPress={() => setCPasswordVisible(!CpasswordVisible)}
        type={CpasswordVisible ? "text" : "password"}
      />

      <SubmitButton
        title={"Update Supervisor PIN"}
        primary
        style={{ width: "70%",marginTop:"30px" }}
        onClick= {() => {
          setPinModal(true);
        }}
       
      />


        {/* ============ CancelModal ===================== */}

      <Modal
        open={pinModal}
        onCancel={() => {
          setPinModal(false);
        }}
        onClickOkButton={() => {
          setPinModal(false);
        }}
        className={styles.Modal}
        // width={"90%"}
        twoButton
        buttonTitle={"ok"}
        onBtnPress={() => setPinModal(false)}
        title={"PIN changed Successfully "}
        btnStyle={{width:"100px"}}
      >
        <TextComponent
          style={{ textAlign: "center" }}
          text="Supervisor PIN has been changed successfully"
        />
      </Modal>
    </div>
  );
};

export default SupervisorPin;
